import {EventType} from '../../../enum/event-type';

export class EmitterEvent {
  private _eventType: EventType;
  private _data: any;

  constructor(eventType: EventType, sendData: any = null) {
    this._eventType = eventType;
    this._data = sendData;
  }

  get eventType(): EventType {
    return this._eventType;
  }

  get data(): any {
    return this._data;
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/event/prototype/emitter-event.ts